<div class="row">
  <div class="col align-items-center d-flex">
    <scitis-color-picker
      (selectedColor)="onSelectSignalColor($event)"
      [displayInput]="false"
      [displayLabel]="false"
      [signalColor]="getHexColor()"
      class="mr-2"
      [disabled]="signalHasBeenDeleted"
      >
    </scitis-color-picker>
    <span class="truncate" style="max-width: 220px;" [ngClass]="{'signal-deleted': signalHasBeenDeleted}" [innerText]="signal.displayedText | translate"></span>
    <span class="ml-1 text-muted">
      <span [innerHTML]="getSignalUnit(signal)"></span>
    </span>
    @if (signalHasBeenDeleted) {
      <em [ngbTooltip]="'The signal does not exist anymore on the asset.'|translate"
        class="fa-solid fa-circle-question text-muted ml-1"
      placement="top"></em>
    }
  </div>
  <div class="col-auto align-items-center d-flex">
    @if (isColorOverwrite) {
      <button (click)="onResetColorToSignalDefault()"
        [ngbTooltip]="'Reset color to signal default'|translate"
        type="button"
        class="btn btn-xs btn-outline-secondary"
        placement="top">
        <span class="fa-solid fa-droplet"></span>
      </button>
    }
    <button (click)="onRemoveSignalFromAxis()"
      [title]="'Remove signal'|translate"
      type="button"
      class="btn btn-xs btn-outline-danger ml-2">
      <span class="fa-solid fa-trash"></span>
    </button>
  </div>
</div>
